import type { PeriodBasedPromoCodeService } from './PeriodBasedPromoCodeService';
import type { PromoCodesService } from './PromoCodesService';
import { getValidPeriodForCode, isCodeValidForPeriod } from '../helpers';

export class PromoCodeApplicationService {
  constructor(
    private promoCodesService: PromoCodesService,
    private periodBasedPromoCodeService: PeriodBasedPromoCodeService,
    private paymentPeriod: string | null
  ) {}

  public api() {
    return {};
  }

  public data() {
    return {};
  }

  public handlers() {
    return {
      submitPromoCode: () => {
        const prepay = this.paymentPeriod;
        const promoCodeInput = this.promoCodesService.getPromoCodeTextFieldValue();
        const promoCode = promoCodeInput.toUpperCase();

        if (prepay && isCodeValidForPeriod(promoCode, prepay)) {
          this.promoCodesService.applyPromoCodeFromTextField();
        } else {
          const validPeriodForCode = getValidPeriodForCode(promoCode);

          if (validPeriodForCode) {
            this.periodBasedPromoCodeService.setPeriodRelatedPromoCodeError(validPeriodForCode);
          }
        }
      },
    };
  }
}
